import React from 'react'

import logoCalendar from '../images/calendar.svg'
import logoLocation from '../images/location.svg'
import logoPhone from '../images/phone.svg'

import './footer.scss'

const Footer = () => (
  <footer className="footer">
    <div className="footer__container">
      <div className="footer__container-item">
        <div className="item__content">
          <img src={logoCalendar} alt="Horaires d’ouverture du cabinet" />
        </div>
        <p>Entretiens sur rendez-vous</p>
        <ul className="u-list-style">
          <li>
            Lundi de <span className="u-bold">10h</span> à{' '}
            <span className="u-bold">19h</span>
          </li>
          <li>
            Mardi de <span className="u-bold">10h</span> à{' '}
            <span className="u-bold">19h</span>
          </li>
          <li>
            Mercredi de <span className="u-bold">10h</span> à{' '}
            <span className="u-bold">19h</span>
          </li>
          <li>
            Jeudi de <span className="u-bold">10h</span> à{' '}
            <span className="u-bold">19h</span>
          </li>
        </ul>
      </div>
      <div className="footer__container-item">
        <div className="item__content">
          <img src={logoLocation} alt="Adresse du cabinet" />
        </div>
        <address>
          <span>300 Rue Auguste Broussonnet </span>
          <br />
          <span>34090</span>
          <span> Montpellier</span> <br />
          Arrêt de tram
          <br /> Place Albert 1er Saint Charles
          <a
            className="footer__container-link"
            target="_blank"
            rel="noopener noreferrer"
            href="https://tam.cartographie.pro"
          >
            Plan d’accès{' '}
          </a>
        </address>
      </div>
      <div className="footer__container-item">
        <div className="item__content">
          <img src={logoPhone} alt="Téléphone et e-mail" />
        </div>
        <a className="footer__container-link" href="tel:+33674318234">
          Tél: 06.74.31.82.34{' '}
        </a>
        <a
          className="footer__container-link footer__container-link--ellipsis"
          href="mailto:psychologue.morgane.laroche@gmail.com"
        >
          psychologue.morgane.laroche@gmail.com
        </a>
      </div>
    </div>
  </footer>
)

export default Footer
